
import { SigninComponent } from './signin.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { RenewPasswordComponent } from './modules/renew-password/renew-password.component';
import { InviteComponent } from './modules/invite/invite.component';
import { MfaCanActivateGuard } from '@app/core/guards/mfa.can-activate.guard';
import { MfaComponent } from './modules/mfa/mfa.component';

export const SIGNIN_ROUTES = [
    {
        path: 'user/invitation/:message', component: InviteComponent
    },
    {
        path: 'forgot/password', component: ForgotPasswordComponent
    },
    {
        path: 'renew/password/:message', component: RenewPasswordComponent
    },
    {
        path: 'mfa',
        component: MfaComponent, 
        canActivate: [MfaCanActivateGuard],
    },
    {
        path: '', component: SigninComponent
    },
];
